import rootReducer from "./reducers/index";
import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import logger from "redux-logger";

const middleWare = [thunk, logger];

const Store = configureStore({
  reducer: rootReducer,
  middleware: [...middleWare],
});
export default Store;
